
import React from "react";
import { Box, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material"
import { Arrayify } from "../../Functions/utils";

export const InputButtonGroup = ({ label, name, value, buttons, onChange }) => {

    return (
        <Box sx={{ width: 280 }}>
            <FormControl >
                <FormLabel id="vt-rb-group-label" sx={{ mt: -1 }}>{label}</FormLabel>
                <RadioGroup
                    row
                    value={value}
                    onChange={onChange}
                    name={name}
                    sx={{ mt: -2 }}
                >
                    {Arrayify(buttons).map((v, i) => (
                        <FormControlLabel
                            key={"RA-rbtype" + i + "-"}
                            value={v}
                            control={
                                <Radio
                                    size="small"
                                    disabled={buttons.length === 1}
                                />
                            }
                            label={v}
                        />
                    ))}
                </RadioGroup>
            </FormControl>
        </Box>
    )
}